module.exports = __webpack_public_path__ + "static/media/cross-mobile-white.d172c0f2.svg";